import { useComponentRegistry } from '@bem-react/di';
import b from 'b_';
import React from 'react';

import { PAGINATOR_ORIENTATION } from '../paginator.constants';
import type { PaginatorPagesProps } from '../types';
import { cnPaginator } from '../utils';

import PaginatorPagesHorizontal from './_horizontal/paginator__pages_horizontal';

import './paginator__pages.scss';

const PaginatorPages = ({ pages, orientation }: PaginatorPagesProps) => {
    const { PaginatorButton } = useComponentRegistry(cnPaginator());

    if (orientation === PAGINATOR_ORIENTATION.HORIZONTAL_RESPONSIVE) {
        return <PaginatorPagesHorizontal orientation={orientation} pages={pages} />;
    }

    return (
        <>
            {pages.map((page, index) => (
                <PaginatorButton
                    clickable={Boolean((page.onClick as unknown) && !page.disabled)}
                    key={index}
                    mix={b('paginator', 'page-button', { orientation })}
                    number={page.number}
                    onClick={!page.disabled ? page.onClick : undefined}
                    selected={page.selected}
                    view={page.view}
                >
                    {page.text}
                </PaginatorButton>
            ))}
        </>
    );
};

export default PaginatorPages;
